import React, { useEffect, useState } from "react";
import { CardContainer } from "../../../components/Card/CardContainer";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import Buttons from "../../../components/Button/Button";
import {
  deleteCoDiscoutTypeById,
  getCoDiscoutTypeById,
  getCreditMemosById,
  getUseageById,
} from "../../../datasource/CODiscountDatasource";
import {
  Badge,
  Card,
  Col,
  ConfigProvider,
  Modal,
  Popover,
  Row,
  Table,
  Tabs,
  Tag,
  Typography,
} from "antd";
import color from "../../../resource/color";
import "./../CODiscountClass.css";
import Text from "../../../components/Text/Text";
import { FlexCol } from "../../../components/Container/Container";
import dayjs from "dayjs";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import { useMessageContext } from "../../../context/MessageProvider";
import { icon, image } from "../../../resource";
import { useEffectOnce } from "react-use";
import { zoneDatasource } from "../../../datasource/ZoneDatasource";
import Permission, { checkPermission } from "../../../components/Permission/Permission";
import { ActionBtn } from "../../../components/Button/TableActionButton";
import { numberFormatter } from "../../../utility/Formatter";
import { useRecoilValue } from "recoil";
import { roleAtom } from "../../../store/RoleAtom";
import { mapStatus } from "../CODiscountList/IndexCODiscountList";
import { FixedType } from "rc-table/lib/interface";

export const DetailCODiscountType: React.FC = () => {
  const { messageApi } = useMessageContext();
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const navigate = useNavigate();
  const id = pathSplit[3];
  const navigateType = pathSplit[4];
  const roleData = useRecoilValue(roleAtom);
  const [tabActiveKey, setTabActiveKey] = useState("list");
  const [data, setData] = useState<any>(null);
  const [dataUsed, setDataUsed] = useState<any>(null);
  const [dataShop, setDataShop] = useState<any>(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [zoneList, setZoneList] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [searchStatus, setSearchStatus] = useState(undefined);
  const [searchText, setSearchText] = useState(undefined);
  const [searchZone, setSearchZone] = useState(undefined);

  const isViewCoList = checkPermission(["coDiscountList", "view"], roleData);

  const fetchData = async () => {
    await getCoDiscoutTypeById(id).then((res) => {
      setData(res);
    });
  };

  const fetchUsed = async () => {
    await getUseageById({
      credit_memo_type_id: id,
      page: page,
      take: 10,
      status: searchStatus,
      search: searchText,
    }).then((res) => {
      setDataUsed(res);
    });
  };

  const fetchShop = async () => {
    await getCreditMemosById({
      credit_memo_type_id: id,
      page: page,
      take: 10,
      status: searchStatus,
      search: searchText,
      zone: searchZone,
    }).then((res) => {
      setDataShop(res);
    });
  };

  const fetchZone = async () => {
    await zoneDatasource.getAllZoneByCompany(profile.company).then((res) => {
      setZoneList(
        res.map((item: any) => {
          return {
            label: item.zoneName,
            value: item.zoneName,
            key: item.zoneName,
          };
        }),
      );
    });
  };

  useEffectOnce(() => {
    fetchData();
    fetchZone();
  });

  useEffect(() => {
    fetchUsed();
    fetchShop();
  }, [page, searchStatus, searchText, searchZone]);

  const PageTitle = () => {
    return (
      <PageTitleNested
        title='รายละเอียดประเภทส่วนลด'
        showBack
        customBreadCrumb={
          <BreadCrumb
            data={[
              {
                text: navigateType === "coDashboard" ? "แดชบอร์ดส่วนลด" : "ประเภทส่วนลด",
                path: -1,
              },
              {
                text: "รายละเอียดประเภทส่วนลด",
                path: window.location.pathname,
              },
            ]}
          />
        }
        extra={
          <Row gutter={8}>
            <Col>
              <Popover
                content={
                  <div
                    style={{
                      fontFamily: "IBM Plex Sans Thai",
                      fontSize: 14,
                      color: color.white,
                    }}
                  >
                    ประเภทนี้กำลังถูกใช้งานในรายการส่วนลด
                    <br /> จึงไม่สามารถแก้ไขหรือลบได้ หากต้องการดำเนินการต่อ
                    <br /> กรุณานำประเภทนี้ออกจากรายการส่วนลดก่อน
                  </div>
                }
                trigger='click'
                color={color.BK}
                placement='bottom'
              >
                <Buttons
                  typeButton={data?.coCount > 0 ? "disabled" : "border-danger"}
                  title='ลบประเภทส่วนลด'
                  icon={
                    <DeleteOutlined
                      style={{ color: data?.coCount > 0 ? color.white : color.error }}
                    />
                  }
                  onClick={() => data?.coCount === 0 && setDeleteModal(true)}
                />
              </Popover>
            </Col>
            <Permission permission={["coDiscountType", "edit"]}>
              <Col>
                <Buttons
                  title='แก้ไขประเภทส่วนลด'
                  icon={<EditOutlined />}
                  onClick={() => navigate("/newDiscountCo/coDiscountType/" + id)}
                />
              </Col>
            </Permission>
          </Row>
        }
      />
    );
  };

  const CardInfo = () => {
    const [seeMore, setSeeMore] = useState(false);

    const mapDataLeft = [
      { label: "สถานะ", value: data?.status ? "เปิดใช้งาน" : "ปิดใช้งาน" },
      { label: "รหัส", value: data?.code },
      { label: "ชื่อประเภทภาษาไทย", value: data?.nameTh },
      { label: "ชื่อประเภทภาษาอังกฤษ", value: data?.nameEn },
    ];
    const mapDataRight = [
      { label: "สี", value: data?.color },
      { label: "ตัวอย่าง", value: data?.color },
      {
        label: "อัปเดตโดย",
        value: `${data?.updateBy}, ${dayjs(data?.updatedAt).format("DD/MM/YYYY, HH:mm น.")} `,
      },
      { label: "รายละเอียด", value: data?.description },
    ];

    return (
      <Card style={{ backgroundColor: "#FAFAFA" }}>
        <Row justify={"space-between"}>
          <Col span={12}>
            {mapDataLeft.map((item, index) => (
              <Row justify={"space-between"} key={index} style={{ padding: "3px" }}>
                <Col span={8}>
                  <Text color='Text3'>{item.label}</Text>
                </Col>
                <Col span={16}>
                  <Text>{item.value}</Text>
                </Col>
              </Row>
            ))}
          </Col>
          <Col span={12}>
            {mapDataRight.map((item, index) => (
              <Row justify={"space-between"} key={index} style={{ padding: "3px" }}>
                <Col span={7}>
                  <Text color='Text3'>{item.label}</Text>
                </Col>
                <Col span={17}>
                  {item.label === "ตัวอย่าง" ? (
                    <>
                      <Tag style={{ backgroundColor: `${item?.value}20`, border: "none" }}>
                        <Typography.Text
                          style={{
                            fontFamily: "IBM Plex Sans Thai",
                            color: item?.value,
                            fontWeight: "bold",
                            fontSize: 15,
                          }}
                        >
                          {data?.code} • {data?.nameTh}
                        </Typography.Text>
                      </Tag>
                    </>
                  ) : item.label === "สี" ? (
                    <Badge key={data?.code} color={data?.color} className='custom-badge' />
                  ) : item.label === "รายละเอียด" ? (
                    <>
                      {!seeMore && (
                        <Text>
                          {item?.value?.length > 95
                            ? `${item?.value?.slice(0, 95)}...`
                            : item?.value || "-"}
                        </Text>
                      )}
                      {seeMore && <Text>{item?.value || "-"}</Text>}{" "}
                      {item?.value?.length > 95 && (
                        <Text
                          color='primary'
                          style={{ cursor: "pointer" }}
                          onClick={() => setSeeMore(!seeMore)}
                        >
                          <u>{seeMore ? "ดูน้อยลง" : "ดูเพิ่มเติม"}</u>
                        </Text>
                      )}
                    </>
                  ) : (
                    <Text>{item?.value}</Text>
                  )}
                </Col>
              </Row>
            ))}
          </Col>
        </Row>
      </Card>
    );
  };

  const columeListTab: any = [
    {
      title: "ชื่อรายการ",
      dataIndex: "name",
      key: "name",
      width: "30%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text level={6} color='Text3'>
                {row.code} • {dayjs(row.startDate).format("DD/MM/YYYY")} -{" "}
                {dayjs(row.endDate).format("DD/MM/YYYY")}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "รวมส่วนลด",
      dataIndex: "totalAmount",
      key: "totalAmount",
      align: "center",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              <Text>{numberFormatter(value)} ฿</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ใช้ไป",
      dataIndex: "usedAmount",
      key: "usedAmount",
      align: "center",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              <Text color={value > 0 ? "error" : "Text1"}>
                {value > 0 ? `- ${numberFormatter(value)}` : numberFormatter(value)} ฿
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "คงเหลือ",
      dataIndex: "balance",
      key: "balance",
      align: "center",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              <Text color={value > 0 ? "EmeraldGreen" : "Text1"}>{numberFormatter(value)} ฿</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "อัปเดตโดย",
      dataIndex: "updateBy",
      key: "updateBy",
      align: "center",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "viewStatus",
      key: "viewStatus",
      align: "center",
      render: (value: any, row: any, index: number) => {
        const calDate = dayjs(row?.endDate).diff(dayjs(), "day");
        const calDateStart = dayjs(row?.startDate).diff(dayjs(), "day");
        return {
          children: (
            <FlexCol style={{ alignItems: "center" }}>
              <Tag
                style={{
                  backgroundColor: mapStatus(value)?.bgColor,
                  border: "none",
                }}
              >
                <Text style={{ color: mapStatus(value)?.textColor }} level={6} fontWeight={600}>
                  {mapStatus(value)?.text}{" "}
                  {calDate <= 7 && value.includes("NEAR") ? `(${calDate} วัน)` : ""}
                  {calDateStart > 0 && value === "ACTIVE" ? `(รอเริ่ม)` : ""}
                </Text>
              </Tag>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ไปที่รายการ",
      dataIndex: "navigate",
      key: "navigate",
      align: "center",
      hidden: !isViewCoList,
      width: "8%",
      fixed: "right" as FixedType | undefined,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "center" }}>
              <Permission permission={["coDiscountList", "view"]}>
                <ActionBtn
                  onClick={() =>
                    navigate("/newDiscountCo/detailCODiscountList/" + row.coId + "/coType")
                  }
                  icon={<UnorderedListOutlined />}
                />
              </Permission>
            </FlexCol>
          ),
        };
      },
    },
  ];

  const columeShopTab: any = [
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text level={6} color='Text3'>
                {row.customerNo} • {row.zone}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "รวมส่วนลด",
      dataIndex: "totalAmount",
      key: "totalAmount",
      align: "center",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              <Text>{numberFormatter(value)} ฿</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ใช้ไป",
      dataIndex: "usedAmount",
      key: "usedAmount",
      align: "center",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              <Text color={value > 0 ? "error" : "Text1"}>
                {value > 0 ? `- ${numberFormatter(value)}` : numberFormatter(value)} ฿
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "คงเหลือ",
      dataIndex: "balance",
      key: "balance",
      align: "center",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              <Text color={value > 0 ? "EmeraldGreen" : "Text1"}>{numberFormatter(value)} ฿</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "center" }}>
              <Tag
                style={{
                  backgroundColor: value === "ACTIVE" ? "#E2FDEB" : "#F3F6F9",
                  border: "none",
                }}
              >
                <Text
                  color={value === "ACTIVE" ? "EmeraldGreen" : "Disable"}
                  level={6}
                  fontWeight={600}
                >
                  {value === "ACTIVE" ? "เปิดใช้งาน" : "ปิดใช้งาน"}
                </Text>
              </Tag>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ไปที่ร้าน",
      dataIndex: "navigate",
      key: "navigate",
      align: "center",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "center" }}>
              <Permission permission={["coDiscountEachShop", "view"]}>
                <ActionBtn
                  onClick={() =>
                    navigate(
                      "/newDiscountCo/detailCoDiscountEachShop/" +
                        row.customerCompanyId +
                        "/coType",
                    )
                  }
                  icon={<UnorderedListOutlined />}
                />
              </Permission>
            </FlexCol>
          ),
        };
      },
    },
  ];

  const onDelete = async () => {
    await deleteCoDiscoutTypeById(id).then((res) => {
      if (res?.success) {
        navigate("/newDiscountCo/coDiscountType");
        messageApi.open({
          type: "error",
          content: "ลบรายการแล้ว ",
          icon: <img src={icon.delete} style={{ width: 14, height: 16 }} />,
        });
      }
    });
  };

  return (
    <>
      <CardContainer>
        <PageTitle />
        <br />
        <Row gutter={8} justify='start' align='middle'>
          <Col>
            <Badge key={data?.code} color={data?.color} className='custom-badge' />
          </Col>
          <Col>
            <Text level={2} fontWeight={600}>
              {data?.code} • {data?.nameTh}
            </Text>
          </Col>
        </Row>
        <Row gutter={8} justify='start'>
          <Col>
            <Tag style={{ backgroundColor: `${data?.color}20`, border: "none" }}>
              <Typography.Text
                style={{ color: data?.color, fontWeight: 600, fontFamily: "IBM Plex Sans Thai" }}
              >
                {dataUsed?.count} รายการกำลังใช้
              </Typography.Text>
            </Tag>
          </Col>
          <Col>
            <Tag style={{ backgroundColor: `${data?.color}20`, border: "none" }}>
              <Typography.Text
                style={{ color: data?.color, fontWeight: 600, fontFamily: "IBM Plex Sans Thai" }}
              >
                {dataShop?.count} ร้านกำลังใช้
              </Typography.Text>
            </Tag>
          </Col>
          <Col>
            <Tag style={{ backgroundColor: data?.status ? "#E2FDEB" : "#F3F6F9", border: "none" }}>
              <Text color={data?.status ? "EmeraldGreen" : "Grey"} fontWeight={600}>
                {data?.status ? "เปิดใช้งาน" : "ปิดใช้งาน"}
              </Text>
            </Tag>
          </Col>
        </Row>
        <br />
        <CardInfo />
        <br />
        <Tabs
          activeKey={tabActiveKey}
          onChange={(key) => {
            setPage(1);
            setSearchStatus(undefined);
            setSearchText(undefined);
            setSearchZone(undefined);
            setTabActiveKey(key);
          }}
          items={[
            {
              label: `รายการที่กำลังใช้`,
              key: "list",
              children: (
                <>
                  <Row justify={"start"} gutter={8}>
                    <Col span={10}>
                      <Input
                        suffix={<SearchOutlined />}
                        allowClear
                        placeholder='ค้นหาชื่อรายการ'
                        value={searchText}
                        onChange={(e) => {
                          if (e) {
                            setSearchText(e.target.value);
                          } else {
                            setSearchText(undefined);
                          }
                        }}
                      />
                    </Col>
                    <Col span={3}>
                      <Select
                        data={[
                          { label: "เปิดใช้งาน", value: "ACTIVE", key: "ACTIVE" },
                          { label: "ปิดใช้งาน", value: "INACTIVE", key: "INACTIVE" },
                          { label: "ใกล้หมดอายุ", value: "NEAR_EXPIRY", key: "NEAR_EXPIRY" },
                          { label: "หมดอายุ", value: "EXPIRED", key: "EXPIRED" },
                        ]}
                        placeholder='เลือกสถานะ'
                        allowClear
                        value={searchStatus}
                        onChange={(value) => {
                          if (value) {
                            setSearchStatus(value);
                          } else {
                            setSearchStatus(undefined);
                          }
                        }}
                      />
                    </Col>
                    <Col style={{ paddingTop: "10px" }}>
                      <Text color='Text3'>ทั้งหมด {dataUsed?.count} รายการ</Text>
                    </Col>
                  </Row>
                  <br />
                  <ConfigProvider
                    theme={{
                      components: {
                        Table: {
                          headerColor: "#FAFAFA",
                          headerBg: "#1B4586",
                          fontFamily: "IBM Plex Sans Thai",
                          fontSize: 15,
                        },
                      },
                    }}
                  >
                    <Table
                      columns={columeListTab}
                      dataSource={dataUsed?.data || []}
                      tableLayout='fixed'
                      scroll={{
                        x: 1300,
                      }}
                      pagination={{
                        position: ["bottomCenter"],
                        total: dataUsed?.count,
                        pageSize: 10,
                        current: page,
                        onChange: (page, pageSize) => {
                          setPage(page);
                        },
                      }}
                      locale={{
                        emptyText: () => (
                          <div
                            style={{
                              height: "300px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Col>
                              <img src={image.emptyTableBrand} alt='empty_table' />
                            </Col>
                            <Col>
                              <div style={{ fontSize: "16px" }}>ไม่มีรายการ</div>
                            </Col>
                          </div>
                        ),
                      }}
                    />
                  </ConfigProvider>
                </>
              ),
            },
            {
              label: `ร้านค้าที่กำลังใช้`,
              key: "shop",
              children: (
                <>
                  <Row justify={"start"} gutter={8}>
                    <Col span={10}>
                      <Input
                        allowClear
                        suffix={<SearchOutlined />}
                        placeholder='ค้นหาชื่อร้านค้า'
                        onChange={(e) => {
                          if (e) {
                            setSearchText(e.target.value);
                          } else {
                            setSearchText(undefined);
                          }
                        }}
                      />
                    </Col>
                    <Col span={3}>
                      <Select
                        value={searchZone}
                        data={zoneList || []}
                        placeholder='เขตร้านค้า'
                        onChange={(value) => {
                          setSearchZone(value);
                        }}
                      />
                    </Col>
                    <Col style={{ paddingTop: "10px" }}>
                      <Text color='Text3'>ทั้งหมด {dataShop?.count} ร้านค้า</Text>
                    </Col>
                  </Row>
                  <br />
                  <ConfigProvider
                    theme={{
                      components: {
                        Table: {
                          headerColor: "#FAFAFA",
                          headerBg: "#1B4586",
                          fontFamily: "IBM Plex Sans Thai",
                          fontSize: 15,
                          rowHoverBg: "none",
                        },
                      },
                    }}
                  >
                    <Table
                      columns={columeShopTab}
                      dataSource={dataShop?.data || []}
                      pagination={{
                        showSizeChanger: false,
                        position: ["bottomCenter"],
                        total: dataShop?.count,
                        pageSize: 10,
                        current: page,
                        onChange: (page, pageSize) => {
                          setPage(page);
                        },
                      }}
                      locale={{
                        emptyText: () => (
                          <div
                            style={{
                              height: "300px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Col>
                              <img src={image.emptyTableBrand} alt='empty_table' />
                            </Col>
                            <Col>
                              <div style={{ fontSize: "16px" }}>ไม่มีรายชื่อร้านค้า</div>
                            </Col>
                          </div>
                        ),
                      }}
                    />
                  </ConfigProvider>
                </>
              ),
            },
          ]}
        />
      </CardContainer>
      {deleteModal && (
        <Modal
          open={deleteModal}
          centered
          closable={false}
          onCancel={() => setDeleteModal(false)}
          onOk={() => {
            onDelete();
          }}
          okText='ยืนยัน'
          cancelText='ยกเลิก'
          okButtonProps={{ danger: true }}
          cancelButtonProps={{ style: { color: color.error, borderColor: color.error } }}
        >
          <Text level={2}>ลบประเภทส่วนลด</Text>
          <br />
          <Text color='Text3'>โปรดยืนยันการลบประเภทส่วนลด</Text>
        </Modal>
      )}
    </>
  );
};
